module.exports = __webpack_public_path__ + "static/media/RUBI_User Guide_rus.2b18d369.png";